import { render, staticRenderFns } from "./xiangqin.vue?vue&type=template&id=393d1de4&scoped=true&"
import script from "./xiangqin.vue?vue&type=script&lang=js&"
export * from "./xiangqin.vue?vue&type=script&lang=js&"
import style0 from "./xiangqin.vue?vue&type=style&index=0&id=393d1de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d1de4",
  null
  
)

export default component.exports